/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Passkey_Failed_BodyInputs */

const en_portalsignin_passkey_failed_body = /** @type {(inputs: Portalsignin_Passkey_Failed_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again, or use the email link.`)
};

/** @type {(inputs: Portalsignin_Passkey_Failed_BodyInputs) => LocalizedString} */
const ar_portalsignin_passkey_failed_body = en_portalsignin_passkey_failed_body;

/** @type {(inputs: Portalsignin_Passkey_Failed_BodyInputs) => LocalizedString} */
const he_portalsignin_passkey_failed_body = en_portalsignin_passkey_failed_body;

/** @type {(inputs: Portalsignin_Passkey_Failed_BodyInputs) => LocalizedString} */
const ur_portalsignin_passkey_failed_body = en_portalsignin_passkey_failed_body;

/** @type {(inputs: Portalsignin_Passkey_Failed_BodyInputs) => LocalizedString} */
const es_portalsignin_passkey_failed_body = en_portalsignin_passkey_failed_body;

/** @type {(inputs: Portalsignin_Passkey_Failed_BodyInputs) => LocalizedString} */
const fr_portalsignin_passkey_failed_body = en_portalsignin_passkey_failed_body;

/** @type {(inputs: Portalsignin_Passkey_Failed_BodyInputs) => LocalizedString} */
const de_portalsignin_passkey_failed_body = en_portalsignin_passkey_failed_body;

/** @type {(inputs: Portalsignin_Passkey_Failed_BodyInputs) => LocalizedString} */
const pt_portalsignin_passkey_failed_body = en_portalsignin_passkey_failed_body;

/** @type {(inputs: Portalsignin_Passkey_Failed_BodyInputs) => LocalizedString} */
const hi_portalsignin_passkey_failed_body = en_portalsignin_passkey_failed_body;

/** @type {(inputs: Portalsignin_Passkey_Failed_BodyInputs) => LocalizedString} */
const bn_portalsignin_passkey_failed_body = en_portalsignin_passkey_failed_body;

/**
* | output |
* | --- |
* | "Try again, or use the email link." |
*
* @param {Portalsignin_Passkey_Failed_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_passkey_failed_body = /** @type {((inputs?: Portalsignin_Passkey_Failed_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Passkey_Failed_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_passkey_failed_body(inputs)
	if (locale === "he") return he_portalsignin_passkey_failed_body(inputs)
	if (locale === "ur") return ur_portalsignin_passkey_failed_body(inputs)
	if (locale === "es") return es_portalsignin_passkey_failed_body(inputs)
	if (locale === "fr") return fr_portalsignin_passkey_failed_body(inputs)
	if (locale === "de") return de_portalsignin_passkey_failed_body(inputs)
	if (locale === "pt") return pt_portalsignin_passkey_failed_body(inputs)
	if (locale === "hi") return hi_portalsignin_passkey_failed_body(inputs)
	if (locale === "bn") return bn_portalsignin_passkey_failed_body(inputs)
	return /** @type {LocalizedString} */ ("Try again, or use the email link.")
});